import createDocumentVersionArray from './createDocumentVersionArray'

export default {
  createDocumentVersionArray,
}
